import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Loader } from 'components/Loader/Loader';
import { ReqEnum } from 'const/requestStatus';
import dayjs, { Dayjs } from 'dayjs';
import { useFetchCourierRating } from '../../hooks/useFetchCourierRating';
import './CourierRating.scss';
import { CourierRatingOverview } from './CourierRatingOverview';
import { CalendarInputComponent } from '../../ReusableComponents/CalendarInput/CalendarInputComponent';
import { Link } from 'react-router-dom';
import { isToday } from '../../utils/date';

export function CourierRating(): JSX.Element {
  const [date, setDate] = useState<Dayjs>(dayjs());
  const [courierRating, fetchCourierRating] = useFetchCourierRating(
    dayjs(date).format('YYYY-MM-DD')
  );

  return (
    <>
      <Helmet>
        <title>{'My Rating'}</title>
      </Helmet>
      <div className="rating-page-background">
        <div className="rating-container">
          <CalendarInputComponent
            date={date}
            blockFutureDates
            setDate={date => {
              setDate(dayjs(date));
            }}
            className="rating-calendar"
          />
          {date.isBefore(new Date('2021-09-15'), 'day') ? (
            <p className="rating-info">
              Please use the <Link to="/my-rating-old">old my rating page</Link>
              .
            </p>
          ) : isToday(date) ? (
            <p className="rating-info">Rating is being calculated</p>
          ) : fetchCourierRating === ReqEnum.PENDING ? (
            <div className="rating-loader">
              <Loader type="spinner" size="xxl" />
            </div>
          ) : (
            <CourierRatingOverview courierRating={courierRating} />
          )}
        </div>
      </div>
    </>
  );
}
